import React, { useEffect, useRef } from 'react';
import { CALL_END } from './assets/svgComponent';
import logger from './utils/logger.js';


const SecondryCamera = () => {
    const videoRef = useRef(null);
    const url = window.location.href;
    const result = url.split("?url=");

    useEffect(() => {
        const getMedia = async () => {
            try {
                // Access the user's webcam
                const stream = await navigator.mediaDevices.getUserMedia({ video: true });
                if (videoRef.current) {
                    // Set the video element source to the webcam stream
                    videoRef.current.srcObject = stream;
                }
            } catch (err) {
                logger.error('Error accessing webcam: ', err);
            }
        };

        getMedia();

        // Cleanup: stop all media tracks when the component is unmounted
        return () => {
            if (videoRef.current && videoRef.current.srcObject) {
                const stream = videoRef.current.srcObject;
                const tracks = stream.getTracks();
                tracks.forEach(track => track.stop());
            }
        };
    }, []);
    const handleClick = () => {
        // Show the confirmation dialog
        const isConfirmed = window.confirm("Are you sure you want to leave the interview?");

        // If the user clicks "OK", redirect to Google
        if (isConfirmed) {
            window.location.href = 'https://www.google.com';
        }
    };
    return (
        <div style={{ height: '100vh', width: '100vw' }}>
            <div style={{ position: 'absolute', zIndex: 999, height: '100vh', width: '100vw' }}>
                <video
                    ref={videoRef}
                    autoPlay
                    muted
                    style={{
                        width: '100vw',
                        height: '100vh',
                        objectFit: 'cover',
                        position: 'absolute',
                        zIndex: 9999,
                    }}
                />
            </div>
            <div>
                <img
                    src={CALL_END}
                    width={40}
                    height={24}
                    style={{
                        cursor: 'pointer',
                        transition: 'transform 0.2s',
                        zIndex: 9999,
                        position: 'absolute',
                        bottom: 40,
                        left: '50%',
                        transform: 'translateX(-50%)',
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                    onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                    alt="End Call"
                    onClick={handleClick}
                />

            </div>
            <iframe
                src={result[1]}
                title="Website"
                width="100%"
                height="100%"
                allow="camera; microphone; fullscreen"
                style={{ zIndex: 1 }} // Ensure iframe is below the video
            ></iframe>
        </div>
    );
};

export default SecondryCamera;
